module.exports = __webpack_public_path__ + "static/img/SV@2x.b428dc54.jpg";